import { Checkbox, Flex, Text } from 'vvs-uikit'
import React from 'react'
import { TokenPairImage } from 'components/TokenImage'
import styled, { css } from 'styled-components'
import { PairDetail, TokenPair } from './type'

type Props = {
  pair: TokenPair
  selected?: boolean
  details?: PairDetail[]
  onChange?: (checked: boolean) => void
  disabled?: boolean
}

export const OptionCard = ({ disabled, selected, pair, details, onChange, ...rest }: Props) => {
  return (
    <FlexOption {...rest} disabled={disabled} justifyContent="space-between" gap="16px">
      <Flex flexDirection="column" gap="16px" flex={1}>
        <Flex justifyContent="space-between">
          <Flex alignItems="center">
            <TokenWrapper>
              <TokenPairImage
                primaryToken={pair.primary}
                secondaryToken={pair.secondary}
                variant="inverted"
                width={32}
                height={32}
              />
            </TokenWrapper>
            <TokenPairText>{pair.label}</TokenPairText>
          </Flex>
        </Flex>
        <Flex rowGap="16px" columnGap="8px" flexDirection={['column', 'column', 'row']}>
          {details?.map((detail) => {
            return (
              <Flex key={detail.label} flexDirection="column" flex={1} flexBasis={['0', '0', '150px']}>
                <DetailLabel>{detail.label}</DetailLabel>
                <DetailValue>{detail.value}</DetailValue>
              </Flex>
            )
          })}
        </Flex>
      </Flex>
      <Flex alignItems="center" width="32px" height="32px">
        <StyledCheckbox
          scale="sm"
          readOnly
          checked={selected}
          onClick={() => {
            onChange?.(!selected)
          }}
          disabled={disabled}
        />
      </Flex>
    </FlexOption>
  )
}

const TokenPairText = styled(Text)`
  font-family: 'Soleil';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`
const TokenWrapper = styled.div`
  top: 4px;
  position: relative;
  padding-right: 8px;
  width: 50px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 60px;
  }
`
const FlexOption = styled(Flex)<{ disabled?: boolean }>`
  padding: 24px 0;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
    `}
`

const StyledCheckbox = styled(Checkbox)`
  margin: 0;

  :not(:checked) {
    background: #e2e0db;
  }
`

const DetailLabel = styled(Text)`
  font-family: 'Soleil';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;

  color: ${({ theme }) => theme.colors.textSubtle};
`

const DetailValue = styled(Text)`
  font-family: 'Soleil';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
`
